import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import withFieldError from 'components/form/with-error'

const MessageInput = ({ input, placeholder }) => (
  <div>
    <input
      className={'form-control right-element-no-borders '}
      type='text'
      placeholder={placeholder}
      {...input}
    />
  </div>
)

MessageInput.propTypes = {
  input: PropTypes.any,
  type: PropTypes.string,
  label: PropTypes.string,
  meta: PropTypes.any,
  placeholder: PropTypes.string
}

const MessageInputWithError = withFieldError(MessageInput)

const FacebookRecurringConsentFields = ({ name }) => (
  <div className='row'>
    <div className='col-sm-12'>
      <Field
        component={MessageInputWithError}
        label='Recurring Consent Title'
        name={`${name}.recurringConsentTitle`}
        placeholder='Title'
      />
    </div>
    <div className='col-sm-12'>
      <Field
        component={MessageInputWithError}
        label='Recurring Consent Image URL'
        name={`${name}.recurringConsentImageUrl`}
        placeholder='Recurring Consent Image URL'
      />
    </div>
  </div>
)

FacebookRecurringConsentFields.propTypes = {
  name: PropTypes.string
}

export default FacebookRecurringConsentFields



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-triggers-actions/actions/facebook/facebook-recurring-consent/index.js